import gql from 'graphql-tag';

export const createNodeMutation = gql`
  mutation createNode(
    $documentPageId: String!
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String
    $append: Boolean
    $payload: CreateNodeInput!
  ) {
    createNode(
      documentPageId: $documentPageId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      append: $append
      payload: $payload
    ) {
      id
    }
  }
`;

export const moveNodesMutation = gql`
  mutation moveNode(
    $documentPageId: String!
    $contentId: String!
    $sourceSectionId: String!
    $sourceRowId: String!
    $sourceCellId: String!
    $sourceNodeIds: [String!]!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String
    $append: Boolean
  ) {
    moveNode(
      documentPageId: $documentPageId
      contentId: $contentId
      sourceSectionId: $sourceSectionId
      sourceRowId: $sourceRowId
      sourceCellId: $sourceCellId
      sourceNodeIds: $sourceNodeIds
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      append: $append
    )
  }
`;

export const updateNodeMutation = gql`
  mutation updateNode(
    $documentPageId: String!
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
    $payload: NodeInput!
  ) {
    updateNode(
      documentPageId: $documentPageId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      payload: $payload
    ) {
      id
    }
  }
`;

export const splitNodeMutation = gql`
  mutation splitNode(
    $documentPageId: String!
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
    $split: SplitInput!
    $create: [SplitCreateInput!]!
  ) {
    splitNode(
      documentPageId: $documentPageId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
      split: $split
      create: $create
    )
  }
`;

export const deleteNodeMutation = gql`
  mutation deleteNode(
    $documentPageId: String!
    $contentId: String!
    $targetSectionId: String!
    $targetRowId: String!
    $targetCellId: String!
    $targetNodeId: String!
  ) {
    deleteNode(
      documentPageId: $documentPageId
      contentId: $contentId
      targetSectionId: $targetSectionId
      targetRowId: $targetRowId
      targetCellId: $targetCellId
      targetNodeId: $targetNodeId
    )
  }
`;

export const uploadImageMutation = gql`
  mutation CreateImage($type: ImageType!, $file: Upload, $url: String, $name: String) {
    createImage(type: $type, file: $file, url: $url, name: $name) {
      id
      url
      imageUrl
    }
  }
`;
